<input
  nbInput
  fullWidth
  type="text"
  [disabled]="disabled ? true : null"
  [ngClass]="config.class ? config.class : ''"
  #inputValue
  (input)="getData(inputValue.value)"
  [placeholder]="placeholder"
  [nbAutocomplete]="auto">

<nb-autocomplete #auto (selectedChange)="onChange($event)">
  <nb-option *ngFor="let item of suggestionData$ | async" [value]="item">
    {{ item.value }}
  </nb-option>
</nb-autocomplete>
